
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetogujratcab() {



    const cardData =
    {
        keyword: 'Pune to Gujarat Cab',
        heading: 'Meghana Cab : Pune to Gujarat Cab',
        headingDescription: 'Meghana Cab offers Pune to Gujarat Cab services, providing a safe, comfortable, and hassle-free travel experience across states. Whether you are traveling for business meetings, cultural visits, or family occasions, our fleet of well-maintained cabs and trained drivers ensure a smooth and secure journey. Choose from multiple vehicle options based on your group size and travel needs, and enjoy 24/7 customer support, on-time service, and competitive pricing. Book your Pune to Gujarat Cab with Meghana Cab and travel with confidence and convenience.',


        top: 'Top Places to Visit in Gujarat with Meghana Cab',

"topPlaces": [
  {
    "title": "Statue of Unity",
    "description": "Standing at 182 meters, the Statue of Unity is the world's tallest statue, dedicated to Sardar Vallabhbhai Patel, India’s first Deputy Prime Minister. Located near Kevadia in the Narmada district, it offers stunning views of the Sardar Sarovar Dam and the surrounding Vindhya and Satpura ranges. The complex includes a museum, sound and laser show, valley of flowers, and riverfront cycling paths, making it an iconic attraction for both national pride and engineering marvel."
  },
  {
    "title": "Gir National Park",
    "description": "Gir National Park is the only place in the world where the majestic Asiatic lions roam free in the wild. Spread over 1,400 square kilometers, the park also shelters leopards, hyenas, deer, crocodiles, and over 300 species of birds. Safari rides through dense teak forests and riverside terrains make it a thrilling and unforgettable wildlife experience."
  },
  {
    "title": "Dwarkadhish Temple",
    "description": "Located in Dwarka, one of the Char Dham pilgrimage sites, the Dwarkadhish Temple is dedicated to Lord Krishna. This 2,500-year-old temple, built in Chalukya style, features intricate carvings and a tall spire with a flag that is changed five times a day. Its coastal location along the Arabian Sea adds to the spiritual and visual appeal for devotees and tourists alike."
  },
  {
    "title": "Rann of Kutch",
    "description": "The Rann of Kutch is a vast white salt desert that turns magical during the Rann Utsav, a winter festival featuring folk music, traditional dance, tent stays, and camel rides under a full moon. It’s one of the most surreal landscapes in India, attracting travelers, photographers, and cultural enthusiasts for a once-in-a-lifetime experience."
  },
  {
    "title": "Somnath Temple",
    "description": "Somnath Temple, one of the twelve Jyotirlingas of Lord Shiva, stands resilient on the western coast of Gujarat. It has been destroyed and rebuilt multiple times through centuries, symbolizing faith and endurance. The temple architecture, with its imposing spire, marble interiors, and the background of ocean waves, makes it a revered spiritual and historical site."
  },
  {
    "title": "Sabarmati Ashram",
    "description": "Situated on the banks of the Sabarmati River in Ahmedabad, Sabarmati Ashram was the residence of Mahatma Gandhi and a pivotal center of India’s freedom movement. Visitors can explore Gandhi's personal belongings, preserved letters, and his spinning wheel. The ashram offers a quiet, reflective atmosphere and deep insight into Gandhian philosophy and non-violent resistance."
  },
  {
    "title": "Sun Temple, Modhera",
    "description": "The Modhera Sun Temple, built in the 11th century by the Solanki dynasty, is dedicated to the solar deity Surya. Its intricate stone carvings, geometric stepwell (Surya Kund), and architectural alignment with solar movements make it an astronomical and cultural wonder. The temple is also the site of the Modhera Dance Festival held annually."
  },
  {
    "title": "Laxmi Vilas Palace",
    "description": "Located in Vadodara, Laxmi Vilas Palace is one of the grandest royal residences in India. Four times the size of Buckingham Palace, it showcases Indo-Saracenic architecture, opulent interiors, ornate balconies, and a private golf course. Visitors can explore its museum, darbar hall, and arms collection for a glimpse into the royal legacy of the Gaekwads."
  },
  {
    "title": "Champaner-Pavagadh Archaeological Park",
    "description": "A UNESCO World Heritage Site, this archaeological park near Vadodara combines Hindu and Islamic architecture across temples, mosques, and stepwells. The Kalika Mata Temple atop Pavagadh Hill attracts pilgrims year-round, while the historic structures below narrate tales of ancient Gujarat's glory. The cable car ride to the hilltop adds an element of adventure."
  },
  {
    "title": "Saputara Hill Station",
    "description": "Saputara is Gujarat's only hill station, located in the Western Ghats near the Maharashtra border. Known for its cool climate, serene lake, tribal museum, sunset point, and lush green landscapes, it offers a perfect retreat for families, honeymooners, and nature lovers. Boating, ropeway rides, and trekking opportunities make it an all-season destination."
  }
],

"services": [
    {
        "name": "Pune to Gujarat One Way Taxi",
        "description": "Book a convenient one-way taxi from Pune to Gujarat with Meghana Cab. Ideal for travelers seeking flexible drop options, our reliable and comfortable cabs ensure timely pickups, door-to-door service, and hassle-free journeys across states."
    },
    {
        "name": "Cab Booking Pune to Gujarat",
        "description": "Easily book your taxi from Pune to Gujarat online with Meghana Cab. Choose from a variety of vehicles including sedans, SUVs, and hatchbacks, all maintained for safety and comfort to guarantee a smooth intercity travel experience."
    },
    {
        "name": "Outstation Cab Pune to Gujarat",
        "description": "Travel stress-free to Gujarat from Pune with Meghana Cab’s outstation taxi services. Our fleet features air-conditioned cars and experienced drivers ensuring safe, comfortable long-distance travel tailored to your schedule."
    },
    {
        "name": "Pune to Gujarat Long-Distance Cabs",
        "description": "Experience comfortable long-distance travel with Meghana Cab’s Pune to Gujarat services. Whether it’s for business or leisure, our spacious, well-maintained vehicles provide a pleasant journey over extended distances."
    },
    {
        "name": "AC Taxi Pune to Gujarat Trip",
        "description": "Stay cool and refreshed throughout your Pune to Gujarat trip with Meghana Cab’s AC taxi service. Our vehicles are equipped with efficient air conditioning systems and offer smooth rides suitable for hot climate travel."
    },
    {
        "name": "Budget Car Rental Pune to Gujarat",
        "description": "Looking for affordable car rental options from Pune to Gujarat? Meghana Cab offers budget-friendly vehicles without compromising on safety or comfort, making your intercity travel economical and convenient."
    },
    {
        "name": "Intercity Taxi Pune to Gujarat",
        "description": "Meghana Cab provides reliable intercity taxi services between Pune and Gujarat, perfect for business commuters, families, and tourists. Enjoy timely pickups, clean vehicles, and courteous drivers dedicated to your convenience."
    },
    {
        "name": "Round Trip Cab Pune to Gujarat",
        "description": "Planning a round trip from Pune to Gujarat? Meghana Cab offers round-trip taxi bookings with flexible scheduling and competitive pricing, ensuring a seamless travel experience for your multi-day or short visits."
    },
    {
        "name": "Book SUV Pune to Gujarat",
        "description": "Travel comfortably with your family or group by booking an SUV from Pune to Gujarat through Meghana Cab. Our SUVs provide ample space, enhanced comfort, and luggage capacity for longer journeys."
    },
    {
        "name": "Family Cab Pune to Gujarat",
        "description": "Meghana Cab specializes in family-friendly taxi services from Pune to Gujarat. Our cars are safe, spacious, and equipped with child-friendly amenities to make your family trips enjoyable and stress-free."
    },
    {
        "name": "Pune to Gujarat Travel Service",
        "description": "Choose Meghana Cab for all your Pune to Gujarat travel needs. From airport pickups to corporate travel and sightseeing tours, our comprehensive taxi services are designed to suit every requirement."
    },
    {
        "name": "Sedan Taxi Pune to Gujarat",
        "description": "Book a stylish and comfortable sedan taxi from Pune to Gujarat with Meghana Cab. Perfect for solo travelers and small groups, our sedans ensure a smooth and efficient ride at affordable prices."
    },
    {
        "name": "Pune to Gujarat Corporate Travel Cab",
        "description": "For business professionals traveling from Pune to Gujarat, Meghana Cab offers premium corporate taxi services featuring punctual pickups, executive-class vehicles, and dedicated support for seamless corporate travel."
    },
    {
        "name": "Cab Service from Pune to Ahmedabad",
        "description": "Travel from Pune to Ahmedabad with Meghana Cab’s trusted cab service. Experience punctual pickups, clean vehicles, and professional drivers who ensure a comfortable and timely journey across cities."
    },
    {
        "name": "Pune to Vadodara Taxi",
        "description": "Book a taxi from Pune to Vadodara with Meghana Cab and enjoy a hassle-free trip. Our drivers are well-versed with the routes, and our cars provide ample comfort for this popular intercity travel."
    }
],

"tableData": [
    ["Pune to Gujarat One Way Taxi", "Cab Booking Pune to Gujarat"],
    ["Outstation Cab Pune to Gujarat", "Pune to Gujarat Long-Distance Cabs"],
    ["AC Taxi Pune to Gujarat Trip", "Budget Car Rental Pune to Gujarat"],
    ["Intercity Taxi Pune to Gujarat", "Round Trip Cab Pune to Gujarat"],
    ["Book SUV Pune to Gujarat", "Family Cab Pune to Gujarat"],
    ["Pune to Gujarat Travel Service", "Sedan Taxi Pune to Gujarat"],
    ["Pune to Gujarat Corporate Travel Cab", "Cab Service from Pune to Ahmedabad"],
    ["Pune to Vadodara Taxi", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Gujarat Cab Service",
        "WhyChoosedescription": "Meghana Cab offers dependable and comfortable cab services from Pune to various cities in Gujarat. Whether you're traveling for business, personal, or tourism purposes, enjoy a smooth journey with our well-equipped vehicles."
    },
    {
        "WhyChooseheading": "Timely Pick-Up and Drop Across Gujarat",
        "WhyChoosedescription": "We ensure on-time pick-ups and drop-offs for your Pune to Gujarat trip. Whether you're heading to Ahmedabad, Surat, Vadodara, or any other city, punctuality is guaranteed with Meghana Cab."
    },
    {
        "WhyChooseheading": "Expert Drivers for Long-Distance Routes",
        "WhyChoosedescription": "Our experienced drivers are familiar with Pune to Gujarat routes and long-distance travel protocols. They focus on safe driving, route efficiency, and customer comfort during the entire trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Enjoy budget-friendly Pune to Gujarat cab fares with no hidden costs. Meghana Cab offers competitive pricing with clear breakdowns, helping you plan your travel expenses confidently."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Vehicles",
        "WhyChoosedescription": "Your safety is our priority. All our cabs are sanitized before every trip and come with safety features like GPS tracking, seat belts, and 24/7 customer support in case of emergencies."
    },
    {
        "WhyChooseheading": "24/7 Availability for Pune to Gujarat Travel",
        "WhyChoosedescription": "Meghana Cab operates 24/7 to accommodate your travel plans. Whether it's an early morning departure or a late-night ride, we’re ready to serve your Pune to Gujarat cab needs anytime."
    },
    {
        "WhyChooseheading": "Customizable Cab Packages",
        "WhyChoosedescription": "We offer flexible travel options for your Pune to Gujarat journey. Choose from one-way trips, round trips, or make multiple stops along the route as per your convenience."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Support",
        "WhyChoosedescription": "Book your Pune to Gujarat cab in just a few clicks through our website or app. Need help? Our support team is always available to assist you with bookings and travel queries."
    }
]



















    }

const faqData = [
    {
        question: "How can I book a Pune to Gujarat cab with Meghana Cab?",
        answer: "You can book a Pune to Gujarat cab easily through Meghana Cab’s website or by calling our customer service at +91 9075462128."
    },
    {
        question: "What cab options are available for travel from Pune to Gujarat?",
        answer: "Meghana Cab offers hatchbacks, sedans, SUVs, and tempo travellers for Pune to Gujarat trips, depending on your group size and comfort preference."
    },
    {
        question: "Is one-way cab service available from Pune to Gujarat?",
        answer: "Yes, we offer both one-way and round-trip cab services from Pune to various destinations in Gujarat."
    },
    {
        question: "How long does it take to travel from Pune to Gujarat by cab?",
        answer: "Travel time varies depending on your exact destination in Gujarat, but on average, the journey takes around 10 to 14 hours."
    },
    {
        question: "Are tolls and taxes included in the cab fare for Pune to Gujarat?",
        answer: "Tolls, state taxes, and parking charges are additional and are clearly communicated during the booking process."
    },
    {
        question: "Are Meghana Cab drivers experienced for long-distance travel like Pune to Gujarat?",
        answer: "Yes, our drivers are experienced, professional, and well-acquainted with long-distance routes including Pune to Gujarat."
    },
    {
        question: "Can I request breaks or custom stops during the Pune to Gujarat journey?",
        answer: "Yes, you can request halts or breaks during the trip. Just let us know your requirements while booking."
    },
    {
        question: "Is the cab service from Pune to Gujarat available at night?",
        answer: "Yes, Meghana Cab provides 24/7 service, so you can book a cab for day or night travel as per your convenience."
    },
    {
        question: "What payment options are accepted for Pune to Gujarat cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash for all bookings."
    },
    {
        question: "How do I contact Meghana Cab to book a Pune to Gujarat cab?",
        answer: "You can contact Meghana Cab at +91 9075462128 for bookings and support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Harshad Patel',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I booked Meghana Cab for a Pune to Gujarat trip, and it was a great experience. The cab was comfortable, and the driver was professional and punctual.”',
    },
    {
        name: 'Mrs. Komal Shah',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We traveled from Pune to Ahmedabad with Meghana Cab. The journey was smooth, safe, and very well-managed. Highly recommended for long-distance travel.”',
    },
];















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Gujarat Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-gujarat-cab.jpg",
  "description": "Book Pune to Gujarat cabs with Meghana Cabs for one-way and round trips. Choose from AC, Sedan, and SUV vehicles for comfortable, affordable, and reliable intercity travel.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5210"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-gujarat-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Gujarat Cab | One Way & Round Trip Taxi | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Gujarat cabs with Meghana Cabs for one-way and round trips. Choose from AC, Sedan, and SUV vehicles for comfortable, affordable, and reliable intercity travel." 
  />
  <meta 
    name="keywords" 
    content="Pune to Gujarat One Way Taxi, Cab Booking Pune to Gujarat, Outstation Cab Pune to Gujarat, Pune to Gujarat Long-Distance Cabs, AC Taxi Pune to Gujarat Trip, Budget Car Rental Pune to Gujarat, Intercity Taxi Pune to Gujarat, Round Trip Cab Pune to Gujarat, Book SUV Pune to Gujarat, Family Cab Pune to Gujarat, Pune to Gujarat Travel Service, Sedan Taxi Pune to Gujarat, Pune to Gujarat Corporate Travel Cab, Cab Service from Pune to Ahmedabad, Pune to Vadodara Taxi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/7.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetogujratcab;